<template>
    <span class="d-inline-flex d-print-none ml-1">
        <template v-if="orderColumn == column">
            <ChevronDownIcon v-if="isSortDesc" size="18" class="text-black"/>
            <ChevronUpIcon v-else size="18" class="text-black"/>
        </template>
        <SortIcon v-else size="15" class="text-black"/>
    </span>
</template>

<script>
import ChevronDownIcon from '@/common/components/svg-icons/ChevronDownIcon.vue';
import ChevronUpIcon from '@/common/components/svg-icons/ChevronUpIcon.vue';
import SortIcon from '@/common/components/svg-icons/SortIcon.vue';

export default {
    name: 'SortDirectionButton',
    props: {
        sortDir: String,
        orderColumn: String,
        column: String
    },
    data() {
        return {};
    },
    computed: {
        isSortDesc() {
            return this.sortDir == 'desc';
        }
    },
    components: {
        ChevronDownIcon,
        ChevronUpIcon,
        SortIcon
    }
};
</script>
